export default {
  BaseURL: 'https://backoffice-webappouistreham.srv11.createurdimage.fr/'
}
